var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "step" } },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex flex-column align-items-center mb-5 chatbotStepContainer",
          class: {
            selected:
              _vm.sidePanelVisible &&
              _vm.selected &&
              _vm.selected._id === _vm.step._id,
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { followCursor: true, placement: "bottom-end" },
                  expression: "{ followCursor: true, placement: 'bottom-end' }",
                },
              ],
              staticClass: "cb-item cb-item-main",
              class:
                ((_obj = {
                  "cb-selected":
                    (_vm.selected && _vm.selected._id === _vm.step._id) ||
                    _vm.path.includes(_vm.step._id),
                }),
                (_obj[_vm.step.type] = true),
                (_obj["bg-danger"] = _vm.step.closeChat),
                (_obj["text-white"] =
                  _vm.step.closeChat ||
                  (!_vm.step.closeChat &&
                    !!!_vm.step.nextStepId &&
                    _vm.step.type === "content") ||
                  (_vm.step.type === "form" && !!!_vm.step.nextStepId)),
                (_obj["bg-warning"] =
                  (!_vm.step.closeChat &&
                    !!!_vm.step.nextStepId &&
                    _vm.step.type === "content") ||
                  (_vm.step.type === "form" && !!!_vm.step.nextStepId)),
                _obj),
              attrs: {
                id: "stepId" + _vm.step._id,
                content: _vm.tippyMessage("content", null),
              },
            },
            [
              _c(
                "div",
                { staticClass: "cb-content h-100" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "text",
                      on: {
                        click: function () {
                          _vm.select(_vm.step)
                          _vm.selectedButton = null
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.step.description) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  !this.step.closeChat && this.step.type !== "menu"
                    ? _c(
                        "a-dropdown",
                        { staticClass: "arrow", attrs: { trigger: ["click"] } },
                        [
                          _c(
                            "a-menu",
                            {
                              attrs: { slot: "overlay" },
                              on: {
                                click: function (e) {
                                  return _vm.addStep(e, _vm.step._id)
                                },
                              },
                              slot: "overlay",
                            },
                            [
                              _c("a-menu-item", { key: "content" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$t("message.contentStep")) +
                                    "\n                        "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("a-menu-item", { key: "form" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$t("message.formStep")) +
                                    "\n                        "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("a-menu-item", { key: "menu" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$t("message.menuStep")) +
                                    "\n                        "
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              staticClass: "p-0",
                              staticStyle: { "z-index": "1" },
                            },
                            [_vm._v("+")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.step.closeChat &&
                  _vm.step.type !== "menu" &&
                  _vm.step.nextStepId !== null
                    ? _c("md-icon", { staticClass: "cb-arrow" }, [
                        _vm._v("\n                    south\n                "),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _vm.step.type === "menu"
            ? _c(
                "div",
                { staticClass: "d-flex justify-content-between mt-3" },
                [
                  _vm._l(_vm.step.menuItems, function (menuItem) {
                    return _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "bottom-end",
                            },
                            expression:
                              "{ followCursor: true, placement: 'bottom-end' }",
                          },
                        ],
                        key: menuItem._id,
                        staticClass: "cb-item mr-3 p-1 menuItem",
                        class: {
                          "cb-selected":
                            (_vm.selectedButton &&
                              _vm.selectedButton._id === menuItem._id) ||
                            _vm.path.includes(menuItem._id),
                          "bg-warning": !_vm.chatSteps.find(function (x) {
                            return x._id === menuItem.nextStepId
                          }),
                          "text-white": !_vm.chatSteps.find(function (x) {
                            return x._id === menuItem.nextStepId
                          }),
                        },
                        attrs: {
                          id: "buttonId" + menuItem._id,
                          content: _vm.tippyMessage("menu", menuItem),
                        },
                        on: {
                          click: function () {
                            _vm.select(_vm.step, true)
                            _vm.selectedButton = menuItem
                          },
                        },
                      },
                      [
                        _c("span", [_vm._v(_vm._s(menuItem.title))]),
                        _vm._v(" "),
                        !_vm.chatSteps.find(function (x) {
                          return x._id === menuItem.nextStepId
                        })
                          ? _c(
                              "a-dropdown",
                              {
                                staticClass: "arrow",
                                attrs: { trigger: ["click"] },
                              },
                              [
                                _c(
                                  "a-menu",
                                  {
                                    attrs: { slot: "overlay" },
                                    on: {
                                      click: function (e) {
                                        return _vm
                                          .addStep(e, null, menuItem)
                                          .then(function (newButton) {
                                            _vm.selectedButton = newButton
                                          })
                                      },
                                    },
                                    slot: "overlay",
                                  },
                                  [
                                    _c("a-menu-item", { key: "content" }, [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.$t("message.contentStep")
                                          ) +
                                          "\n                        "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("a-menu-item", { key: "form" }, [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.$t("message.formStep")) +
                                          "\n                        "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("a-menu-item", { key: "menu" }, [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.$t("message.menuStep")) +
                                          "\n                        "
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("a-button", { staticClass: "p-0" }, [
                                  _vm._v("+"),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _vm.step.showPrevMenuButton
                    ? _c("div", { staticClass: "cb-item mr-3 p-1" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("message.prevStep"))),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.step.showLiveChatButton
                    ? _c("div", { staticClass: "cb-item mr-3 p-1" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("message.goToLive"))),
                        ]),
                      ])
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.step.nextStepId !== null
        ? _c("Step", {
            attrs: {
              "add-step": _vm.addStep,
              path: _vm.path,
              select: _vm.select,
              selected: _vm.selected,
              sidePanelVisible: _vm.sidePanelVisible,
              step: _vm.chatSteps.find(function (x) {
                return x._id === _vm.step.nextStepId
              }),
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedButton &&
      _vm.selectedButton.nextStepId !== null &&
      _vm.chatSteps.find(function (x) {
        return x._id === _vm.selectedButton.nextStepId
      })
        ? _c("Step", {
            key: _vm.selectedButton && _vm.selectedButton._id,
            attrs: {
              "add-step": _vm.addStep,
              path: _vm.path,
              select: _vm.select,
              selected: _vm.selected,
              sidePanelVisible: _vm.sidePanelVisible,
              step: _vm.chatSteps.find(function (x) {
                return x._id === _vm.selectedButton.nextStepId
              }),
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }